import React, { useState, memo } from "react";
import SimpleModalVideo from "../Common/SimpleModalVideo";

const Banner = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div id="home" className="uk-banner main-banner item-bg1">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="uk-container">
              <div className="main-banner-content">
                <h1>
                  グローバルな
                  <br />
                  ウェブ開発
                </h1>
                <p>世界で通用するを武器にする時代へ</p>
                <a href="#contact" className="uk-button uk-button-default">
                  Get Started
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SimpleModalVideo
        channel="youtube"
        videoId="dQw4w9WgXcQ"
        isOpen={isOpen}
        onClose={closeModal}
      />
    </>
  );
};

export default memo(Banner);
